
(function($){
    // JS
    window.Team = {

        // Team member grid blocks
        //======================================================================
        toggleBio: function()
        {
            var target = $('.js-team-target');

            // toggle the bio of the team member
            $(document).on('click', '.js-team-toggle', function(e){
                e.preventDefault();

                current = $(this).next(target);

                target.not(current).slideUp('fast');
                current.slideToggle('fast');
                
            });
        },
        equalHeight: function()
        {
            $(document).ready(function(){
                var toggle = $('.js-team-toggle');

                // Get largest toggle and apply that style to all for equal heights
                var numArr = [];
                toggle.each(function(index, element){
                    var targetHeight = $(element).outerHeight();
                    numArr.push(targetHeight);
                });

                var largest = Math.max.apply(null, numArr);

                toggle.css({
                    height: largest
                });
            });
            
        }
    }
    // Run
    $(function(){
        Team.toggleBio();
        Team.equalHeight();
    });


}(jQuery));